<template>
  <div class="container">
    <PublicHeader :totalName="$t('share').Commissiontransferout" />
    <!-- 佣金 -->
    <div class="banlceInfo">
      <div class="txt">{{ $t('share').commission }}</div>
      <div class="num">${{ userInfo.commissionAmount.toFixed(2).replace(/\.?0+$/, '') }}</div>
    </div>
    <div class="excInfo">
      <div class="line"></div>
      <div class="exchange">
        <div class="info">
          <svg-icon class-name="svgs" icon-class="arrow" />
        </div>
      </div>
      <div class="line"></div>
    </div>
    <div class="doInfo">
      <div class="currency">
        <div class="txt">
          <div class="nusd">$</div><span>USD</span>
        </div>
        <div class="rate">{{ $t('share').Transferfiaaccount }}</div>
      </div>
      <van-field v-model="amount" :placeholder="$t('share').amount" />
    </div>
    <!-- 按钮 -->
    <van-button block @click="handleSub">{{ $t('share').Confirmtransferout }}</van-button>
  </div>
</template>

<script>
import userApi from '@/api/user'
import { mapGetters } from 'vuex'
import PublicHeader from '@/components/publicHeader'

export default {
  components: {
    PublicHeader
  },
  data() {
    return {
      amount: '',
      userInfo: { commissionAmount: 0 },
      showPopover: false,
    }
  },
  watch: {
    amount() {
      // 余额校验
      if (this.amount > this.userInfo.commissionAmount)
        this.$toast(this.$t('public').BalanceNot)
    },
  },
  computed: {
    ...mapGetters(['basicConfig'])
  },
  mounted() {
    this.getMemberInfo()
  },
  methods: {
    // 获取用户信息
    async getMemberInfo() {
      const res = await userApi.getMemberInfo()
      this.userInfo = res.user
    },
    // 提交
    async handleSub() {
      if (!this.amount) {
        this.$toast(this.$t('public').BalanceNot)
        return false
      }
      // 余额校验
      if (this.amount > this.userInfo.commissionAmount) {
        this.$toast(this.$t('public').BalanceNot)
        return false
      }
      const form = {
        amount: this.amount,
      }
      await userApi.transferOut(form)
      this.$toast(this.$t('share').Transfersuccessful)
      this.$router.go(-1)
    },
  }
}
</script>

<style lang="less" scoped>
.container {
  min-height: 100vh;
  width: 100%;
  padding: 65px 15px 0 15px;
  background: var(--background_color);

  .banlceInfo {
    background: var(--info_color);
    border-radius: 10px;
    padding: 20px;

    .txt {
      font-size: 13px;
      color: var(--text_color);
    }

    .num {
      margin-top: 10px;
      font-size: 24px;
      font-weight: bold;
      color: var(--primary_color);
    }
  }

  .excInfo {
    margin: 20px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .line {
      height: 1px;
      background: var(--info_color);
      width: 120px;
    }

    .exchange {
      margin: 0 15px;
      width: 56px;
      height: 56px;
      background: var(--info_color);
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;

      .info {
        width: 40px;
        height: 40px;
        background: var(--primary_color);
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;

        .svgs {
          width: 25px;
          height: 25px;
          color: #fff;
          transform: rotate(90deg);
        }
      }
    }
  }

  .doInfo {
    margin-top: 20px;
    background: var(--info_color);
    padding: 20px;
    border-radius: 15px;

    .currency {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 15px;

      .txt {
        display: flex;
        align-items: center;

        .nusd {
          width: 43px;
          height: 43px;
          background: var(--primary_color);
          border-radius: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 30px;
          font-weight: bold;
          color: #fff;
        }

        span {
          margin-left: 15px;
          font-size: 18px;
          color: var(--primary_color);
        }
      }

      .rate {
        height: 25px;
        padding: 0 10px;
        background: var(--primary_color);
        border-radius: 12px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 12px;
        color: #fff;
      }
    }
  }

  .van-button {
    margin-top: 50px;
    background: var(--primary_color);
    height: 40px;
    border-radius: 20px;
    border: 0;
    font-size: 15px;
    color: #fff;
  }
}

::v-deep .van-field__value {
  overflow: visible;
  display: grid;
}

::v-deep .van-field__control {
  color: var(--text_color);
}

::v-deep .van-field__control::-webkit-input-placeholder {
  color: var(--text_color);
  opacity: 0.9;
}

::v-deep .van-cell {
  background: var(--background_color);
  padding: 0 15px 0 15px;
  border-radius: 15px;
  font-size: 22px;
  height: 45px;
}
</style>
